import React, { Fragment } from 'react';
import clsx from 'clsx';
import SvgOK from '@icons/check-circle.svg?react';

interface ComponentProps {
  /** 1-based index of the active step; steps below it render as done (green + check). */
  activeStep: number;
  totalSteps?: number;
  /** Colors the ACTIVE step and its incoming connector: ok = green, warning = yellow, error = red; default orange. */
  outcome?: 'ok' | 'warning' | 'error';
}

const outcomeBg = { ok: 'bg-complementary-success', warning: 'bg-complementary-warning', error: 'bg-complementary-error' };

/** Static wizard progress of the duplication flow: done steps green with a check, active step colored by outcome. */
const DuplicationStepper: React.FC<ComponentProps> = ({ activeStep, totalSteps = 3, outcome }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);
  const activeBg = outcome != null ? outcomeBg[outcome] : 'bg-content-brand';
  const stepBg = (step: number) => (step < activeStep ? 'bg-complementary-success' : step === activeStep ? activeBg : 'bg-content-primary');
  return (
    <div className={'flex flex-row items-center w-full max-w-xl self-center'}>
      {steps.map(step => (
        <Fragment key={step}>
          {step > 1 && <div className={clsx('flex-1 h-0.5', stepBg(step))} />}
          <div className={clsx('flex items-center justify-center w-6 h-6 rounded-full text-sm text-white shrink-0', stepBg(step))}>
            {step < activeStep || (step === activeStep && outcome === 'ok') ? <SvgOK className={'w-4 h-4 text-white'} /> : step}
          </div>
        </Fragment>
      ))}
    </div>
  );
};

export default DuplicationStepper;
